import axios from 'axios'

const ltbaseurl = 'https://www.latercera.com'

export default {
  getFromAPI(path, resolve, reject) {
    axios.get(path)
    .then(response => {
      resolve({
        posts: response.data
      })
    })
    .catch(error => reject(error))
  },
  getPostsFallback(path){
    return new Promise((resolve, reject) => {
      this.getFromAPI(path, resolve, reject)
    })
  },
  getPostsByTagId(tagsid) {
    const path = `${ltbaseurl}/wp-json/wp/v2/posts/?tags=${tagsid}&per_page=50`
    return new Promise((resolve, reject) => {
      this.getFromAPI(path, resolve, reject)
    })
  },
  getPost(slug) {
    const path = `${ltbaseurl}/wp-json/wp/v2/posts/?slug=${slug}`
    return new Promise((resolve, reject) => {
      this.getFromAPI(path, resolve, reject)
    })
  }
}